import { Timings } from './ClientPerfMetrics'

export interface IEnvironmentSettings {
  sessionId: string
  correlationId: string
  version: string
  ring: string
  ExampleSettingOnlyTrueInInternal: boolean
  DisableOneNotePagesInFeed?: boolean
  DisableHtmlRendering?: boolean
  DisableOTelLogging?: boolean
  RedirectToOutlookNotesFolder?: boolean
}

export interface ISettingsForClient {
  Locale: string
  ServerSidePerfMetrics: Timings
  GraphResourceUri: string,
  OutlookResourceUri: string,
  OneNoteResourceUri: string,
}

/*
  Controlled: Service Worker is active, and it is intercepting the network requests.
  Supported: Service Worker is supported on client's browser, but it is not yet active.
  Unsupported: Service Worker is not supported on client's browser.
*/
export enum ServiceWorkerStatus {
  CONTROLLED = 'Controlled',
  SUPPORTED = 'Supported',
  UNSUPPORTED = 'Unsupported',
}
